import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateSupplierForm from "../../forms/CreateOrUpdateSupplierForm";
import { SupplierResponseDto } from "../../shared/dtos/supplier/SupplierResponseDto";

const UpdateSupplierModal: React.FC<{
  open: boolean;
  onClose: () => void;
  supplier: SupplierResponseDto;
  loading: boolean;
  error: string | null;
}> = ({ open, onClose, supplier, loading, error }) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit Supplier: ${supplier.name}`}
    width="md"
    loading={loading}
  >
    <CreateOrUpdateSupplierForm
      isEditing={true}
      supplier={supplier}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateSupplierModal;
